const actionNames = {
  GET_DATA_REFRESH_REQUESTED: 'GET_DATA_REFRESH_REQUESTED',
  GET_DATA_REFRESH_SUCCEEDED: 'GET_DATA_REFRESH_SUCCEEDED',
  GET_DATA_REFRESH_FAILED: 'GET_DATA_REFRESH_FAILED',

  GET_DATA_REFRESHED_TIME_REQUESTED: 'GET_DATA_REFRESHED_TIME_REQUESTED',
  GET_DATA_REFRESHED_TIME_SUCCEEDED: 'GET_DATA_REFRESHED_TIME_SUCCEEDED',
  GET_DATA_REFRESHED_TIME_FAILED: 'GET_DATA_REFRESHED_TIME_FAILED',

  GET_SEARCH_REQUESTED: 'GET_SEARCH_REQUESTED',
  GET_SEARCH_SUCCEEDED: 'GET_SEARCH_SUCCEEDED',
  GET_SEARCH_FAILED: 'GET_SEARCH_FAILED',

  UPDATE_SEARCH_TERM: 'UPDATE_SEARCH_TERM',
  UPDATE_RECENT_SEARCHES: 'UPDATE_RECENT_SEARCHES',

  GET_SUMMARIES_REQUESTED: 'GET_SUMMARIES_REQUESTED',
  GET_SUMMARIES_SUCCEEDED: 'GET_SUMMARIES_SUCCEEDED',
  GET_SUMMARIES_FAILED: 'GET_SUMMARIES_FAILED',

  GET_SUMMARY_REQUESTED: 'GET_SUMMARY_REQUESTED',
  GET_SUMMARY_SUCCEEDED: 'GET_SUMMARY_SUCCEEDED',
  GET_SUMMARY_FAILED: 'GET_SUMMARY_FAILED',
}

export default actionNames
